module.exports = __webpack_public_path__ + "img/imgCYYQ(4).5f23986f.png";